<template>
	<v-card class="elevation-0 forums-page page mb-3">
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null">
			<v-card
				class="post-preview-card elevation-0 d-flex flex-column"
				v-if="forums[0] && forums[0].category.category_name"
				style="margin-bottom: 30px"
			>
				<div class="post-preview-card__title mt-1">
					{{ forums[0].category.category_name }}
				</div>
			</v-card>
			<div class="forums-page__wrap">
				<div class="d-flex">
					<v-skeleton-loader width="600" v-bind="attrs" type="card" v-if="false">
					</v-skeleton-loader>
					<FeaturedPost :post="{}" v-else />
				</div>
			</div>
			<FilterChipButtons
				class="mb-2"
				:isButtonActive="isButtonActive"
				:chipsList="chipsList"
				:clearFilter="clearFilter"
				@handleChipClick="handleChipClick"
			/>
			<div v-if="filterModalIsVisible">
				<FilterModal
					:filterModalIsVisible="filterModalIsVisible"
					:currentModalFilter="currentModalFilter"
					:currentModalLabel="currentModalLabel"
					:selectedChips="selectedChips"
					:filters="filters"
					@closeModal="closeModal"
					@applySelection="applySelection"
					@setItem="setItem"
				/>
			</div>

			<div
				class="post__fake-btn-modal-container mt-0"
				@click="openCreatePostModal"
				v-if="!this.isLoading"
			>
				<div>
					<Avatar
						class="mr-4 post-preview-card__avatar"
						size="30"
						:avatar="profile.user_logo"
					/>
					What’s on your mind?
				</div>

				<div>
					<img :src="penIcon" alt="penIcon" loading="lazy" />
				</div>
			</div>

			<Banner v-if="banner && !isLoading" :banner="banner" :mt="12" />

			<div class="d-flex mt-3">
				<v-skeleton-loader
					v-if="isLoading"
					v-bind="attrs"
					width="600"
					type="list-item, list-item-three-line, card-heading"
				></v-skeleton-loader>
				<div v-else style="width: 100%">
					<div v-if="forums.length === 0" class="mt-5 page-container">
						<NewsFeedEmpty
							title="Your forum posts is empty at the moment."
							description="Check back later or create a new post."
						/>
					</div>
					<div v-for="(forum, index) in forums" :key="index">
						<ForumPreview :forum="forum" />
					</div>
				</div>
			</div>

			<div
				class="d-flex my-9 justify-center home-page__pagination"
				v-if="!isLoading && forums.length > 0"
			>
				<Pagination
					:page="filters.page"
					:pageCount="+this.pageForums"
					v-on:pageChange="onPageChange"
				/>
			</div>

			<div v-if="isShowCreatePostModal">
				<CreatePostModal
					v-on:closeModal="closeCreatePostModal"
					:show="isShowCreatePostModal"
					:categoryId="categoryId"
				/>
			</div>

			<v-btn
				v-show="isShowCreatePostButton"
				@click="openCreatePostModal"
				bottom
				right
				class="add-post-button"
				fixed
				fab
			>
				<v-icon>mdi-plus</v-icon>
			</v-btn>

			<v-btn v-show="isVisible" @click="scrollToTop" bottom right fixed fab>
				<v-icon>mdi-chevron-up</v-icon>
			</v-btn>
		</div>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import FeaturedPost from '@/components/Post/PostFeaturedPreview'
import searchIcon from '@/assets/images/search.svg'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty'
import ForumPreview from '@/components/Forum/ForumPreview'
import CreatePostModal from '@/components/Modals/CreateForumPostModal.vue'
import Pagination from '@/components/Pagination.vue'
import PageBlocked from '@/components/PageBlocked'
import Block from '@/mixins/Block.js'
import penIcon from '@/assets/images/icon-pen.svg'
import Avatar from '@/components/Avatar'
import Banner from '@/components/Banner'
import Filter from '@/mixins/Filter'
import FilterChipButtons from '@/components/FilterChipButtons.vue'
import FilterModal from '@/components/Modals/FilterModal.vue'

export default {
	name: 'EventsPage',
	mixins: [Block, Filter],
	components: {
		FilterModal,
		FilterChipButtons,
		CreatePostModal,
		FeaturedPost,
		NewsFeedEmpty,
		ForumPreview,
		Pagination,
		PageBlocked,
		Avatar,
		Banner,
	},

	methods: {
		...mapActions('forum', ['fetchForums']),
		...mapActions('advertisement', ['getBanner', 'clearBanner']),

		toggleVisibility() {
			this.isVisible = window.scrollY > 1000
		},
		scrollToTop() {
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			})
		},
		checkScreenWidth() {
			this.isShowCreatePostButton = window.innerWidth >= 1264
		},
		onPageChange(page) {
			if (this.filters.page !== page) {
				const params = {
					search: this.filters.search,
					page: page,
				}
				this.filters.page = page
				const queryString = this.formatFilters(params)
				this.getForums(queryString)
			}
		},
		openCreatePostModal() {
			this.isShowCreatePostModal = true
		},
		closeCreatePostModal() {
			this.isShowCreatePostModal = false
		},

		formatFilters(filters) {
			const { search, page } = filters

			let queryString = `&category_id=${this.$route.params.id}&page=${page}`

			if (search !== undefined && search.length > 0) {
				queryString += `&search=${search}`
			}

			return queryString
		},

		async getForums(additionalQueryParams = '') {
			await this.fetchForums(additionalQueryParams)
		},
	},

	created() {
		if (!this.isBlocked || this.isBlocked === null) {
			this.fetchForums(this.requestQuery)
			this.getBanner({
				places: ['forum_posts'],
				place_sub_id: this.$route.params.id,
				page: this.filters.page,
			})
		}
	},

	computed: {
		...mapGetters('forum', ['forums', 'isLoading', 'pageForums']),
		...mapGetters('auth', ['profile']),
		...mapGetters('advertisement', ['banner']),

		categoryId() {
			if (this.$route.params.id !== undefined) {
				return this.$route.params.id
			}

			return null
		},
	},

	mounted() {
		window.addEventListener('scroll', this.toggleVisibility)
		window.addEventListener('resize', this.checkScreenWidth)
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.toggleVisibility)
		window.addEventListener('resize', this.checkScreenWidth)
		this.clearBanner()
	},

	data() {
		return {
			attrs: {
				class: 'mb-6 mt-6',
				elevation: 0,
			},
			penIcon,
			isVisible: false,
			isShowCreatePostButton: true,
			isShowCreatePostModal: false,
			filters: {
				page: 1,
				search: '',
			},
			searchIcon,

			search: '',
			page: '',
			pageBlockedName: 'forums',
		}
	},
}
</script>

<style lang="scss">
.forums-page {
	background: #f1f1f1 !important;
	max-width: 600px;
	width: 100%;

	&__divider {
		border-color: #000 !important;
		mix-blend-mode: normal;
		opacity: 0.1;
	}

	&__time {
		color: rgb(74, 74, 74);
		font-size: 24px;
		font-family: Montserrat;
		font-weight: bold;
	}

	.event {
		&__search {
			background: white;
			height: 54px;
			border-radius: 10px;
			border: 1px solid rgb(230, 230, 230);
		}

		&__filters {
			color: white;
			font-size: 14px;
			font-family: Montserrat;
			font-weight: bold;
			letter-spacing: 0.36px;
			margin-top: 20px;
			background: rgb(65, 161, 216) !important;
			border-radius: 15px;
			box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);
			text-transform: capitalize !important;
			align-items: center;
		}

		@media screen and (max-width: 1264px) {
			&__search {
				max-width: none;
			}
		}
	}

	.post {
		&__search {
			background: white;
			height: 54px;
			border-radius: 10px;
			border: 1px solid rgb(230, 230, 230);
			max-width: 600px;
		}
	}
}

.post {
	&__search {
		background: white;
		height: 54px;
		border-radius: 10px;
		border: 1px solid rgb(230, 230, 230);
		max-width: 600px;
	}

	&__fake-btn-modal {
		&-container {
			display: flex;
			align-items: center;
			justify-content: space-between;
			height: 54px;
			background: rgb(255, 255, 255);
			border: 1px solid rgb(230, 230, 230);
			border-radius: 10px;
			padding: 20px 15px;
			max-width: 600px;
			cursor: pointer;

			color: rgb(160, 160, 160);
			font-size: 15px;
			font-family: Montserrat, sans-serif;
			font-weight: normal;
			letter-spacing: -0.43px;
		}
	}

	@media screen and (max-width: 1264px) {
		&__search {
			max-width: none;
			width: 100%;
		}
		&__fake-btn-modal-container {
			max-width: none;
			width: 100%;
		}
	}
}

.page-container {
	max-width: 600px;
}
</style>
